import { makeStyles } from '@material-ui/core';

const ACCENT = '#4B5EE6';
const INK = '#171E33';
const MUTED = '#7A8397';
const FAINT = '#A0A8BA';

export const GRID_COLUMNS = '1fr 82px 86px 82px 44px';

export const useStyles = makeStyles(() => ({
  paper: {
    width: '100%',
    maxWidth: 680,
    margin: 16,
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 24px 70px rgba(23,30,51,0.28)'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '30px 32px 22px'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: '#EEF0FE',
    color: ACCENT,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '5px 11px',
    borderRadius: 999,
    marginBottom: 12
  },
  badgeDot: {
    width: 6,
    height: 6,
    borderRadius: 999,
    background: ACCENT,
    display: 'inline-block'
  },
  title: {
    fontSize: 23,
    fontWeight: 700,
    color: INK,
    lineHeight: 1.2,
    margin: 0
  },
  subtitle: {
    fontSize: 14,
    color: MUTED,
    marginTop: 7,
    maxWidth: 420,
    lineHeight: 1.5
  },
  close: {
    width: 34,
    height: 34,
    flex: 'none',
    border: 'none',
    background: '#F2F4F8',
    borderRadius: 10,
    color: MUTED,
    fontSize: 17,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#E6E9F0',
      color: INK
    }
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: GRID_COLUMNS,
    gap: 10,
    padding: '0 32px 10px',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: FAINT
  },
  rows: {
    padding: '0 20px',
    maxHeight: '46vh',
    overflowY: 'auto'
  },
  row: {
    cursor: 'pointer',
    display: 'grid',
    gridTemplateColumns: GRID_COLUMNS,
    gap: 10,
    alignItems: 'center',
    padding: '15px 12px',
    borderRadius: 14,
    marginBottom: 4,
    border: '1.5px solid #EEF0F5',
    background: '#FFFFFF',
    transition: 'all 0.12s ease'
  },
  rowSelected: {
    border: '1.5px solid #C7CEFB',
    background: '#F6F7FF'
  },
  fileCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0
  },
  fileIcon: {
    width: 38,
    height: 38,
    flex: 'none',
    borderRadius: 10,
    background: '#EEF0FE',
    color: ACCENT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16
  },
  fileName: {
    fontSize: 14,
    fontWeight: 600,
    color: INK,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  fileMeta: {
    fontSize: 12,
    color: FAINT,
    marginTop: 2
  },
  cell: {
    fontSize: 13,
    color: '#4A5266',
    fontVariantNumeric: 'tabular-nums'
  },
  rateCell: {
    fontSize: 13,
    fontWeight: 600,
    color: INK,
    fontVariantNumeric: 'tabular-nums'
  },
  checkWrap: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  check: {
    width: 22,
    height: 22,
    borderRadius: 7,
    border: '2px solid #CDD3DF',
    background: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 12,
    fontWeight: 700
  },
  checkOn: {
    border: `2px solid ${ACCENT}`,
    background: ACCENT
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    padding: '22px 32px 28px',
    marginTop: 14,
    borderTop: '1px solid #EEF0F5'
  },
  selectedLabel: {
    fontSize: 12,
    color: FAINT,
    fontWeight: 500
  },
  totalLabel: {
    fontSize: 22,
    fontWeight: 700,
    color: INK,
    marginTop: 2
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  cancel: {
    border: 'none',
    background: 'transparent',
    color: MUTED,
    fontSize: 14,
    fontWeight: 600,
    padding: '13px 18px',
    borderRadius: 12,
    cursor: 'pointer',
    '&:hover': {
      background: '#F2F4F8'
    }
  },
  cta: {
    border: 'none',
    background: ACCENT,
    color: '#fff',
    fontSize: 14.5,
    fontWeight: 600,
    padding: '14px 24px',
    borderRadius: 12,
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(75,94,230,0.35)',
    transition: 'all 0.12s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    '&:disabled': {
      background: '#C3C9D6',
      cursor: 'not-allowed',
      boxShadow: 'none'
    }
  }
}));
